<template>
  <div class="material-list-wrapper">
    <div class="material-list-content">
      <material-item
        v-for="(item, index) in infoList"
        :key="index"
        :material-item-data="item"
        :invitations="invitations"
        @handleClickItem="handleClickItem"
      ></material-item>
      <w-more-loading v-if="infoList.length < infoCount"></w-more-loading>
      <w-no-more v-if="isEnd"></w-no-more>
    </div>
  </div>
</template>

<script>
import materialItem from './components/material-item.vue'
import WMoreLoading from '../../components/global/w-more-loading'
import WNoMore from '../../components/global/w-no-more'
import { envMixin, loginMixin } from '../../assets/js/mixin/global'
export default {
  components: {
    materialItem,
    WMoreLoading,
    WNoMore,
  },
  mixins: [envMixin, loginMixin],
  data() {
    return {
      infoList: [],
      invitations: [],
      page: 1,
      infoCount: 0,
    }
  },
  watch: {},
  computed: {
    isEnd() {
      return this.infoCount <= this.infoList.length
    },
  },
  methods: {
    handleClickItem(data) {
      if (this.isWxMini) {
        this.$wechat.miniProgram.navigateTo({
          url: `/pages/campaign/campaign?src=${process.env.VUE_APP_HOST}/campaign/materials/${data.id}`,
        })
      } else {
        this.$router.push(`/campaign/materials/${data.id}`)
      }
    },
    async fetchConfigurationInfos() {
      try {
        const { code, data } = await this.$api.campaign.getConfigurationInfos({
          category: 'info',
          page: this.page,
          size: 14,
        })
        if (code === 1000) {
          this.infoList =
            this.page === 1 ? data.infos : [...this.infoList, ...data.infos]
          this.infoCount = data.info_count
          this.invitations = data.invitations
        }
      } catch (error) {
        console.error(`fetch configuration info error`, error)
      }
    },
    handleScroll() {
      const documentHeight = document.documentElement.scrollHeight

      // 获取窗口可视区域的高度
      const windowHeight = window.innerHeight

      // 获取当前滚动位置
      const scrollY = window.scrollY

      // 判断是否触底
      if (scrollY + windowHeight >= documentHeight && !this.isEnd) {
        // 在触底时触发你的操作
        this.page += 1
        this.fetchConfigurationInfos()
        // 你可以在这里执行加载更多内容的操作或其他操作
      }
    },
  },
  async created() {
    await this.miniprogramAutoLogin()
    this.fetchConfigurationInfos()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style scoped lang="scss">
@import '../../assets/scss/global/mixin.scss';
.material-list-wrapper {
  min-height: 100vh;
  background-color: #f9f9f8;
  .material-list-content {
    display: flex;
    flex-wrap: wrap;
    padding: 12px 16px;
    @include ipx-content-bottom(12px);
  }
}
</style>
